import axios from './main'
import routes from './routes'

export const assignAdsVideo = async (videoId, ads_ids) => {
  try {
    const { data } = await axios.put(routes.assignAdsVideo(videoId), ads_ids)
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const getAdsVideo = async (videoId) => {
  try {
    const { data } = await axios.get(routes.getAdsVideo(videoId))
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const createAds = async (createData, type) => {
  let config = undefined
  if (type === 'image') {
    config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  }
  try {
    const { data } = await axios.post(routes.createAds(), createData, config)
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const updateAds = async (adsId, updatedData, type) => {
  let config = undefined
  if (type === 'image') {
    config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  }
  try {
    const { data } = await axios.patch(routes.updateAds(adsId), updatedData, config)
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getAllAds = async () => {
  try {
    const { data } = await axios.get(routes.getAllAds())
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const getAds = async (adsId) => {
  try {
    const { data } = await axios.get(routes.getAds(adsId))
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const deleteAds = async (adsId) => {
  try {
    const { data } = await axios.delete(routes.deleteAds(adsId))
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
